// Written by Codex on 2026-10-16
// User prompt: Fix leave case refresh and browser history navigation.
const RETURN_PAGES = new Set(['pending', 'all-leaves', 'leave-hub']);
export function safeCaseState(state) {
  if (typeof state?.requestId !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(state.requestId)) return null;
  return { requestId: state.requestId, returnTo: RETURN_PAGES.has(state.returnTo) ? state.returnTo : 'pending' };
}
export function caseStateFromPath(pathname) {
  const match = /^\/app\/leave-case\/([^/]+)(?:\/([^/]+))?\/?$/.exec(pathname);
  if (!match) return null;
  try { return safeCaseState({ requestId: decodeURIComponent(match[1]), returnTo: match[2] }); }
  catch { return null; }
}
export function casePagePath(state) {
  const safe = safeCaseState(state);
  return safe ? `leave-case/${encodeURIComponent(safe.requestId)}/${safe.returnTo}` : 'leave-case';
}
